import React from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import { Typewriter } from "react-simple-typewriter";

const Hform = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  // Step 2: Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://topfaculty.co.in/api/web_lead.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData), // Must be JSON encoded!
        }
      );

      const result = await response.json();
      console.log("API Response:", result);

      if (result.status === "success") {
        Swal.fire("Success!", result.message, "success");
        setFormData({ name: "", phone: "", email: "" });
      } else {
        Swal.fire("Error!", result.message, "error");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      Swal.fire("Error!", "Network error or invalid response", "error");
    }
  };

  return (
    <>
      <div id="rs-latest-news" className="rs-latest-news sec-spacer">
        <div className="container">
          <div className="row">
            <h2 className="title text-center    mt-2 ">
              📚BENEFITS TO{" "}
              <strong style={{ color: "#f7b205" }}>CONNECT WITH US</strong>
            </h2>
            <div className="col-md-6">
              <div className="news-normal-block">
                <div className="news-img">
                  <a href="#">
                    <img src="assetsfront/images/add3.png" alt="" />
                  </a>
                </div>

                {/* <div className="news-btn">
                  <a href="#">Read More</a>
                </div> */}
              </div>
            </div>

            {/* <div className="col-md-2">
          <img src="https://i.pinimg.com/originals/13/cd/26/13cd26345c9b8f0572255571a2e4fd92.gif" style={{height:"530px"}} alt="" />
             </div> */}

            <div className="col-md-6">
              <div className=" news-normal-block">
                <div className="news-list-block">
                  <div className="container">
                    <div className="row">
                      {/* <div className="col-md-3">
                        <img
                          src="https://i.pinimg.com/originals/13/cd/26/13cd26345c9b8f0572255571a2e4fd92.gif"
                          style={{ height: "500px" }}
                          alt=""
                        />
                      </div> */}
                      <div className="col-md-12">
                        <div className="rs-banner-section3 ">
                          <div className="register-form ">
                            <div className="form-title text-center">
                              <h5 className="title">
                             <strong style={{ color: "#f7b205", fontWeight: "800",fontSize: "18px" }}><Typewriter
                                  words={[
                                    "   Register now ",
                                    " अभी रजिस्टर करें ",
                                  ]}
                                  loop
                                  cursor
                                  cursorStyle="."
                                  typeSpeed={100}
                                  deleteSpeed={50}
                                  delaySpeed={2000}
                                /></strong> <br />
                                
                                 for getting 50+
                                 
                                courses free access. This offer
                                
                                for limited time.
                               
                              </h5>
                            </div>
                            <div className="form-group text-center">
                              <form
                                id="contact-form"
                                className="contact-form "
                                method="post"
                                onSubmit={handleSubmit}
                              >
                                <div className="row">
                                  <div className="col-lg-6">
                                    <input
                                      className="from-control"
                                      name="name"
                                      value={formData.name}
                                      onChange={handleChange}
                                      type="text"
                                      placeholder="Name"
                                      id="name"
                                      required="required"
                                    />
                                  </div>
                                  <div className="col-lg-6">
                                    <input
                                      className="from-control"
                                      name="phone"
                                      value={formData.phone}
                                      onChange={handleChange}
                                      type="number"
                                      placeholder="Phone Number"
                                      id="phone_number"
                                      required="required"
                                    />
                                  </div>
                                  <div className="col-lg-12">
                                    <input
                                      className="from-control"
                                      name="email"
                                      value={formData.email}
                                      onChange={handleChange}
                                      type="email"
                                      placeholder="E-Mail"
                                      id="email"
                                      required="required"
                                    />
                                  </div>

                                  <div className="col-lg-12">
                                    <input
                                      type="submit"
                                      defaultValue="Get It Now"
                                      className="wpcf7-form-control wpcf7-submit"
                                    />
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Latest News End */}
    </>
  );
};

export default Hform;
